/**
 * Empty-state copy for the Notification Center panel — Flutter parity
 * with `notification_center_screen.dart:161-169`.
 *
 * Flutter copy: `S.of(context).noNotificaion` (note the Flutter typo —
 * missing `t`). React picks the correctly-spelled English literal
 * "No Notifications" per CLAUDE.md (translation-lookup ≠ user-facing
 * literal; the typo is a Flutter translation-bundle bug, not a wire
 * literal we must preserve).
 */
export function NotificationEmptyState() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <p className="[font:var(--type-body)] text-[var(--ink-meta)]">
        No Notifications
      </p>
    </div>
  );
}
